import { authApiCall } from "../../../auth";

export const getAllUsers = () => {
  return authApiCall({
    url: `/users/admin/all-users/`,
    method: 'get',
  });
};
